import React, { useState } from 'react';
import AiakoVoiceCall from './AiakoVoiceCall';
import AiakoChatCall from './AiakoChatCall';

const AiakoLanding: React.FC = () => {
  const [showVoiceCall, setShowVoiceCall] = useState(false);
  const [showChatCall, setShowChatCall] = useState(false);
  const [showMicModal, setShowMicModal] = useState(false);

  if (showVoiceCall) {
    return <AiakoVoiceCall onBack={() => setShowVoiceCall(false)} />;
  }

  if (showChatCall) {
    return <AiakoChatCall onBack={() => setShowChatCall(false)} />;
  }

  const handleStartCall = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({ name: 'microphone' as PermissionName });
      if (permissionStatus.state === 'granted') {
        setShowVoiceCall(true);
      } else if (permissionStatus.state === 'prompt') {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          stream.getTracks().forEach(t => t.stop());
          setShowVoiceCall(true);
        } catch {
          setShowMicModal(true);
        }
      } else {
        setShowMicModal(true);
      }
    } catch {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach(t => t.stop());
        setShowVoiceCall(true);
      } catch {
        setShowMicModal(true);
      }
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#F6F8F8' }}
    >
      {/* Header */}
      <div className="w-full p-2">
        <div className="w-full max-w-[1200px] mx-auto p-2 flex justify-between items-center">
          <span
            className="text-xl font-bold leading-7"
            style={{ color: '#161618', letterSpacing: '-0.3px' }}
          >
            Aiako
          </span>
        </div>
      </div>

      {/* Main */}
      <div className="flex-1 flex flex-col justify-center items-center py-10 px-4">
        <div
          className="w-full max-w-[640px] bg-white rounded-3xl flex flex-col justify-center items-center gap-6 py-12 px-6"
          style={{
            boxShadow: '0px 9px 20px rgba(209,209,209,0.10), 0px 37px 37px rgba(209,209,209,0.09), 0px 82px 49px rgba(209,209,209,0.05), 0px 147px 59px rgba(209,209,209,0.01), 0px 229px 64px rgba(209,209,209,0)',
          }}
        >
          {/* Avatar */}
          <div className="w-36 h-36 relative rounded-full flex-shrink-0">
            <div
              className="absolute left-3 top-3 w-[120px] h-[120px] rounded-full overflow-hidden"
              style={{ background: '#770032' }}
            >
              <img src="/davy-5665cdbf.png" alt="Aiako" className="w-full h-full object-cover" />
            </div>
          </div>

          {/* Info */}
          <div className="w-full flex flex-col items-center gap-1 px-5 md:px-20">
            <div className="flex flex-col items-center gap-2">
              <div
                className="px-2 py-0.5 rounded-full flex items-center justify-center"
                style={{ backgroundColor: '#E7F8F3' }}
              >
                <span className="text-xs leading-4" style={{ color: '#058A62', fontWeight: 450 }}>
                  Available
                </span>
              </div>
              <p
                className="text-center text-xl font-bold leading-7"
                style={{ color: '#161618', letterSpacing: '-0.3px' }}
              >
                Ask Aiako AI
              </p>
            </div>
            <p
              className="text-center text-sm leading-5 w-full"
              style={{ color: '#58595A', fontWeight: 450, letterSpacing: '-0.084px' }}
            >
              Get instant answers to your questions, all in one place.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-4">
            <button
              onClick={handleStartCall}
              className="h-10 px-6 rounded-full flex items-center gap-2 cursor-pointer"
              style={{ backgroundColor: '#CC0044' }}
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 12.5a2.5 2.5 0 0 0 2.5-2.5V5a2.5 2.5 0 0 0-5 0v5a2.5 2.5 0 0 0 2.5 2.5Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.25 10a6.25 6.25 0 0 1-12.5 0M10 16.25V18.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-sm leading-5 text-white" style={{ fontWeight: 450, letterSpacing: '-0.084px' }}>
                Start call
              </span>
            </button>

            <button
              className="h-10 px-6 rounded-full flex items-center gap-2 cursor-pointer"
              style={{ backgroundColor: '#F9EFF2' }}
              onClick={() => setShowChatCall(true)}
            >
              <span className="text-sm leading-5" style={{ color: '#CC0044', fontWeight: 450, letterSpacing: '-0.084px' }}>
                Start chat
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="w-full p-2">
        <div className="w-full max-w-[1200px] mx-auto p-2 flex justify-between items-center">
          <div className="flex items-end gap-1">
            <span className="text-xs leading-4" style={{ color: '#7E7F81', fontWeight: 450 }}>
              Powered by
            </span>
            <img src="/logos/Hupo_Logotype_Orange(noR).svg" alt="Hupo" className="h-3.5" />
          </div>
        </div>
      </div>

      {/* Mic Permission Modal */}
      {showMicModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
          <div
            className="flex w-full max-w-[600px] flex-col gap-2 rounded-2xl bg-white px-4 py-6"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex items-start gap-2">
              <div className="h-5 w-5 shrink-0 mt-0.5">
                <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10" cy="10" r="8.333" fill="#CC0044" />
                  <path d="M10 10V6.667" stroke="white" strokeWidth="1.25" strokeLinecap="round" />
                  <circle cx="10" cy="13.333" r="0.833" fill="white" />
                </svg>
              </div>
              <p className="flex-1 text-base font-semibold leading-6" style={{ color: '#161618', letterSpacing: '-0.16px' }}>
                Please allow microphone access so Aiako can hear you.
              </p>
            </div>

            <ol className="list-decimal pl-7 space-y-1 text-base leading-6" style={{ color: '#58595A', fontWeight: 450, letterSpacing: '-0.16px' }}>
              <li>
                Tap <span className="font-semibold" style={{ color: '#161618' }}>Allow</span> on the browser pop-up.
              </li>
              <li>
                If no pop-up appears, open your browser <span className="font-semibold" style={{ color: '#161618' }}>settings</span> and enable <span className="font-semibold" style={{ color: '#161618' }}>microphone access</span> for this site.
              </li>
            </ol>

            <div className="flex justify-end pt-4">
              <button
                type="button"
                onClick={() => setShowMicModal(false)}
                className="h-10 px-6 rounded-full text-sm leading-5 cursor-pointer"
                style={{ backgroundColor: '#CC0044', color: 'white', fontWeight: 450, letterSpacing: '-0.084px' }}
              >
                Ok, got it
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AiakoLanding;
